import { replace } from 'react-router-redux';
import { put } from 'redux-saga/effects';

import { logout, LOGOUT_ORIGIN } from 'utils/logout';

import { getLoginUrlWithRedirect } from './redirect';
import ROUTES from '../routes/constants';

export function* logoutAndRedirect() {
  yield put(
    logout(LOGOUT_ORIGIN.LOGOUT_AND_REDIRECT, getLoginUrlWithRedirect()),
  );
}

export function* redirectToForbidden() {
  yield put(replace(ROUTES.FORBIDDEN_PATH));
}
export function* redirectToError() {
  yield put(replace(ROUTES.ERROR_PATH));
}
export function* redirectToProfileConflict() {
  const currentUrl = window.location.href;

  window.location.href = `${
    process.env.PORTFOLIO_URL
  }?referrer=${encodeURIComponent(currentUrl)}&origin=agents_pwa`;
}
